<ng-container *transloco="let t">
    <div class="modal-header d-flex justify-content-between align-items-center ps-0 pe-2">
        <div>
            <img class="header-img" src="assets/img/svg/T.svg" alt="Tracey logo">
        </div>
        <div class="d-flex justify-content-start w-100">
            <div class="fw-semibold title-wrapper line-height-1">
                {{ title | transloco }}
            </div>
        </div>
        <div class="d-flex justify-content-center align-items-center pe-20">
            <button type="button"
                    class="btn-close"
                    aria-label="Close"
                    (click)="onClose.emit()">
            </button>
        </div>
    </div>
    <div class="modal-body">
        <div class="body-wrapper">
                <ng-content></ng-content>
        </div>
    </div>
    <div class="modal-footer d-flex justify-content-center align-items-center" *ngIf="showActions">
            <div class="pe-3" *ngIf="showCancel">
                <app-rounded-button
                        [label]="t(cancelLabel)"
                        [btnClass]="'rounded-button--black-outline'"
                        (onClick)="handleCancel()">
                </app-rounded-button>
            </div>

            <app-rounded-button
                    *ngIf="showSave"
                    [label]="t(saveLabel)"
                    [btnClass]="'rounded-button--solid'"
                    [isDisabled]="saveDisabled"
                    (onClick)="onSave.emit()">
            </app-rounded-button>
    </div>
</ng-container>
